import Controller from '@ember/controller';
import { service } from '@ember/service';
import type BetaToggleService from 'scaleflow/services/beta-toggle';

export default class ScansScanIndexController extends Controller {
  @service declare betaToggle: BetaToggleService;
}
